var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 11.2501C22 10.4701 21.9286 9.72012 21.7959 9.00012H11.2245V13.2601H17.2653C17 14.6301 16.2041 15.7901 15.0102 16.5701V19.3401H18.6531C20.7755 17.4201 22 14.6001 22 11.2501Z",
    fill: "#8047FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2245 22.0001C14.2551 22.0001 16.7959 21.0201 18.6531 19.3401L15.0102 16.5701C14.0102 17.2301 12.7347 17.6301 11.2245 17.6301C8.30614 17.6301 5.82655 15.7001 4.9388 13.1001H1.2041V15.9401C3.05104 19.5301 6.83675 22.0001 11.2245 22.0001Z",
    fill: "#8047FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.93878 13.0901C4.71429 12.4301 4.58163 11.7301 4.58163 11.0001C4.58163 10.2701 4.71429 9.57007 4.93878 8.91007V6.07007H1.20408C0.438776 7.55007 0 9.22007 0 11.0001C0 12.7801 0.438776 14.4501 1.20408 15.9301L4.11225 13.7101L4.93878 13.0901Z",
    fill: "#8047FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2245 4.38012C12.8776 4.38012 14.347 4.94012 15.5204 6.02012L18.7347 2.87012C16.7857 1.09012 14.2551 0.00012207 11.2245 0.00012207C6.83675 0.00012207 3.05104 2.47012 1.2041 6.07012L4.9388 8.91012C5.82655 6.31012 8.30614 4.38012 11.2245 4.38012Z",
    fill: "#8047FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bda86f1887c4819609b6876edaf3deb7.svg";
export { ForwardRef as ReactComponent };